<app-spinner *ngIf="loading" [sizeClass]="'large'"></app-spinner>
<div *ngIf="!loading && !noAvailableRange" class="net-price-by-partner">
  <h3 translate>T_PRICE_MANAGEMENT_NET_PRICE_TTTLE</h3>
  <div class="price-partner-actions">
    <button (click)="fileInput.click()" class="btn btn-default-gray-background" translate type="button">
      <em class="pi pi-download">&nbsp;</em>
      T_PRICE_IMPORT
      <input #fileInput (change)="fileUploader($event)" accept=".xlsx, .xls" style="display:none" type="file" />
    </button>
    <button (click)="fileExport()" class="btn btn-default-gray-background btn-export" translate type="button">
      <em class="pi pi-upload">&nbsp;</em>
      T_PRICE_EXPORT
    </button>
  </div>
  <div class="net-price-by-partner-form">
    <!-- PARTNER SELECT -->
    <label for="partner" translate>T_PRICE_MANAGEMENT_PARTNER_LABEL</label>
    <select (change)="refreshNetPriceDiscount()" [(ngModel)]="netPriceSelectedPartner" class="select" id="partner">
      <option [ngValue]="undefined" selected translate>T_PRICE_MANAGEMENT_CHOOSE_PARTNER</option>
      <option *ngFor="let partner of partnerOfCountry">{{partner}}</option>
    </select>

    <!-- RANGE SELECT -->
    <label for="range" translate>T_RANGE</label>
    <select (change)="refreshNetPriceDiscount()" [(ngModel)]="netPriceSelectedRange" class="select" id="range">
      <option [ngValue]="undefined" selected translate>T_PRICE_MANAGEMENT_CHOOSE_RANGE</option>
      <option *ngFor="let range of ranges" [ngValue]="range">{{range.nameKey | translate}}</option>
    </select>

    <!-- NET PRICE DISCOUNT FIELD -->
    <label for="netPriceDiscount" translate>T_DISCOUNT</label>
    <input (blur)="onChangePartnerDiscount($event.target.value)" [(ngModel)]="netPricesDiscount" [disabled]="invalidPartnerOrRangeSelected()" class="form-control discount-number" id="netPriceDiscount" max="{{MAX_DISCOUNT_ALLOWED}}"
           min="{{MIN_DISCOUNT_ALLOWED}}" step="0.01"
           type="number">

    <!-- UPDATE BUTTON -->
    <button (click)="updateNetPricesDiscountForPartner()" [disabled]="invalidPartnerOrRangeSelected()" class="btn btn-group btn-primary button-div" translate type="button">T_PRICE_MANAGEMENT_UPDATE_BUTTON</button>

    <!-- RANGE LIST BUTTON -->
    <button (click)="showNetPriceDiscountModal()" [disabled]="!netPriceSelectedPartner" class="btn btn-group btn-primary button-div" translate type="button"><em class="se-icons">table</em></button>
  </div>
</div>

<div *ngIf="noAvailableRange &&!loading " class="no-range-message">
  <span translate>T_NO_RANGE_MESSAGE</span>
</div>

<app-common-modal #netPriceDiscountModal [closable]="false" [name]="'netPriceDiscountModal'" [withFooter]="false">
  <div modal-body>
    <div class="row net-price-by-partner align-items-center">
      <div class="col-md-5 form-right">
      <label for="partnerModal" translate>T_PRICE_MANAGEMENT_PARTNER_LABEL<span> :</span></label>
      </div>
      <div class="col-md-7">
      <select (change)="refreshRange()" [(ngModel)]="netPriceSelectedPartner" class="select" id="partnerModal">
        <option *ngFor="let partner of partnerOfCountry">{{partner}}</option>
      </select>
      </div>
    </div>
    <div *ngFor="let discount of rangeDiscountList" class="row net-price-by-partner">
      <div class="col-md-5 form-right">
        <label [for]="discount[0].nameKey">{{discount[0].nameKey | translate}}<span> :</span></label>
      </div>
      <div class="col-md-7">
        <input (blur)="onChangePartnerDiscountList(discount, $event.target.value)" [id]="discount[0].nameKey" [value]="discount[1]" class="form-control discount-number" max="{{MAX_DISCOUNT_ALLOWED}}"
               min="{{MIN_DISCOUNT_ALLOWED}}" step="0.01"
               type="number">
        <span>%</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 form-center">
        <button (click)="updateNetPricesDiscountForAllRangesPartner(); closeModal()" [disabled]="!modalSaveButtonEnabled" class="btn btn-group btn-default-white-background button-div"
                translate type="button">T_BUTTON_SAVE</button>
      </div>
      <div class="col-md-6 form-center">
        <button (click)="closeModal()" [tooltip]="modalSaveButtonEnabled ? 'All unsaved modification will be lost' : ''"
                class="btn btn-group btn-default-white-background button-div"
                translate type="button">
          T_CLOSE</button>
      </div>
    </div>
  </div>
</app-common-modal>

<!-- discount exeed modal -->
<app-common-modal #exeedDiscountModal [name]="'exeedDiscountModal'" [twoButtonsDialogs]="false">
</app-common-modal>

<!-- discount inferior to the max discount by partner modal -->
<app-common-modal #inferiorDiscountModal [name]="'inferiorDiscountModal'" [twoButtonsDialogs]="false">
</app-common-modal>
